import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { isFuture, isValid, formatISO, add, format } from 'date-fns'
import { Box } from '@material-ui/core'

import DateTimePicker from 'material/DateTimePicker'

export const exampleDate = format(add(new Date(), { hours: 1 }), 'MM/dd/yyyy hh:mm a').replace(',', '')

const Schedule = ({ date, onUpdate }) => {
  const [isInvalid, setIsInvalid] = useState(isValid(date))
  const errorMessage = `Date must be a valid future date & time. (Example: ${exampleDate})`
  return (
    <Box pb={1.5}>
      <DateTimePicker
        name="ScheduledDate"
        id="ScheduledDate"
        required
        mask="__/__/____ __:__ _M"
        fullWidth
        views={['date', 'hours', 'minutes']}
        openTo="date"
        hideTabs
        date={date}
        onChange={(newDate) => {
          const isValidDate = isValid(newDate)
          const isPastTime = isValidDate && !isFuture(newDate)
          const isInvalidDate = !isValidDate || isPastTime
          setIsInvalid(isInvalidDate)
          return isInvalidDate ? onUpdate(newDate) : onUpdate(formatISO(newDate))
        }}
        FormHelperTextProps={{ role: 'alert' }}
        autoOk
        label="Send Date"
        error={isInvalid}
        helperText={isInvalid ? errorMessage : undefined}
        format="MM/dd/yyyy hh:mm aa"
        disablePast
      />
    </Box>
  )
}

Schedule.propTypes = {
  date: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  onUpdate: PropTypes.func.isRequired,
}

export default Schedule

export {
  SCHEDULED_FIELD_NAME,
  defaultDateTomorrow,
  hasValidScheduledDate,
  getDefaultScheduledDate,
} from 'components/ComposeOutreachMessageButton/services/helpers'
